export Datagrid from './Datagrid';
export RxDatagrid from './ReduxDatagrid';
export reducer from './reducer';
export FilterField from './FilterField';
export FilterResetButton from './FilterResetButton';

export const actions = {
	setFilter: require('./actions').setFilter
};


// WEBPACK FOOTER //
// ./src/reactis/reactis-datagrid/src/index.js